import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@cmps/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { CmpsDatePipe } from '../common/date.pipe';
import { ModalWebFormComponent } from '../webform/modal-webform.component';
import { WidgetConfiguration } from '../widget/config.widget.model';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';
import { WidgetService } from '../widget/widget.service';
import {
    createWebFormsScorecardUrl,
    generateScorecardModalHeader,
} from '../widget/widget.util';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import {
    PersonalScorecardList,
    PersonalScorecardListItem,
} from './personal-scorecard-list.widget.model';

@Component({
    selector: 'cmps-widget-personal-scorecard-list',
    templateUrl: './personal-scorecard-list.widget.component.html',
})
export class PersonalScorecardListWidgetComponent implements OnInit, OnDestroy {
    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    data: PersonalScorecardList;
    private _modal: NgbModalRef;

    constructor(
        private readonly _modalService: NgbModal,
        private readonly _translateService: TranslateService,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
        @Inject(CMPS_WIDGET_CONFIG) public config: WidgetConfiguration,
        private readonly _widgetService: WidgetService,
        private readonly _service: LegacyWidgetService,
        private readonly _datePipe: CmpsDatePipe,
    ) {}

    ngOnInit(): void {
        this.hasPendingData = true;
        this._service
            .personalScorecardList()
            // eslint-disable-next-line no-return-assign
            .subscribe(
                (data) => (this.data = data),
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }

    ngOnDestroy(): void {
        if (this._modal) {
            this._modal.close();
        }
    }

    showScorecard(item: PersonalScorecardListItem): void {
        const header = generateScorecardModalHeader(
            this._translateService,
            this._datePipe,
            null,
            item.startDate,
            item.endDate,
        );
        const url = `${
            this._appConfig.WEB_FORMS_BASE_URL
        }${createWebFormsScorecardUrl(this._datePipe, {
            id: item.id,
            name: item.name,
            userId: item.userId,
            startDate: item.startDate,
            endDate: item.endDate,
            periodTypeId: this._widgetService.dateRange.value.type,
        })}`;

        this._modal = this._modalService.open(ModalWebFormComponent, {
            windowClass: 'cmps-iframe-scorecard',
        });
        this._modal.componentInstance.config = {
            header,
            currentUrl: url,
        };
        this._modal.componentInstance.hasScrolling = false;
        // eslint-disable-next-line no-return-assign
        this._modal.result.then(
            (result) => (this._modal = null),
            (reason) => (this._modal = null),
        );
    }
}
